<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="para"> </p>
<p class="dedication"><a id="page_v"></a>Dedicated to Constance Helen Foster,<br/>March 1, 1951–March 17, 2006.<br/>A woman of great heart, noble spirit, and high courage.<br/>She was a true woman of valor.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?6eb5e3bc